import { get } from "../client";
import { CATEGORIES } from "../routes";

export default {
  get: async () => await get(CATEGORIES),
};
